import clsx from 'clsx';
import styles from './navigation.module.scss';
import React from 'react';
import { useDrag } from '@use-gesture/react';

interface Props {
    onChange: (idx: number, dir: 'left' | 'right') => void;
    currentIndex: number;
}

export const Navigation: React.FC<Props> = ({ currentIndex, onChange }) => {
    const handleChangeLeftNavigate = (dir: 'left' | 'right') => {
        onChange(currentIndex, dir);
    };

    const bindSwipe = useDrag(
        ({ movement: [mx, _], cancel, active, last }) => {
            if (last) {
                if (mx < 0) {
                    handleChangeLeftNavigate('right');
                } else {
                    handleChangeLeftNavigate('left');
                }
            }
        },
        { axis: 'x' },
    );

    return (
        <div
            className={clsx(styles.navigation, 'pressable')}
            {...bindSwipe()}
            style={{ touchAction: 'none' }}>
            <div
                onClick={() => handleChangeLeftNavigate('left')}
                className={clsx(styles.navigationItem, styles.navigationLeft)}
            >
                Left
            </div>
            <div
                onClick={() => handleChangeLeftNavigate('right')}
                className={clsx(styles.navigationItem, styles.navigationRight)}
            >
                Right
            </div>
        </div>
    );
};
